import { render, staticRenderFns } from "./DeleteRequestReview.vue?vue&type=template&id=1f1e9577&scoped=true"
import script from "./DeleteRequestReview.vue?vue&type=script&lang=js"
export * from "./DeleteRequestReview.vue?vue&type=script&lang=js"
import style0 from "./DeleteRequestReview.vue?vue&type=style&index=0&id=1f1e9577&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1e9577",
  null
  
)

export default component.exports